import React from 'react';
import { Button } from '@mui/material';

import { OfferWithScope_UserWithoutId } from '../helpers/DataStructures';
import { translateFromTechnicalToEnglish } from '../helpers/Language';
import { getCompanyLogoPath } from '../helpers/companyBranding';
import { DisplayOfferInGridBody } from './DisplayOfferInGrid';

interface DisplayOfferInGridWrapperProps {
  offer: OfferWithScope_UserWithoutId;
  onActionButtonClick: (offer: OfferWithScope_UserWithoutId) => void;
}

const logoStyle: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: '80px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  display: 'block',
};

const DisplayOfferInGridWrapper: React.FC<DisplayOfferInGridWrapperProps> = ({
  offer,
  onActionButtonClick,
}) => {
  const { user, location, offeringFixedCashAmount } = offer;

  const getCompanyLogo = (companyName?: string) => {
    const logoPath = getCompanyLogoPath(companyName);
    if (!logoPath) {
      return undefined;
    }

    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '5px 10px',
          boxSizing: 'border-box',
        }}
      >
        <img
          src={logoPath}
          alt="Company Logo"
          style={logoStyle}
          loading="lazy"
          decoding="async"
        />
      </div>
    );
  };

  return (
    <div>
      <DisplayOfferInGridBody
        Company={user.companyName || ''}
        Profession={translateFromTechnicalToEnglish(user.profession)}
        CompanyLogo={getCompanyLogo(user.companyName)}
        Location={location === 'Not Specified' ? '' : location}
        // REQ-033: render currency through an escaped code point so source encoding cannot corrupt it.
        Offer={<>{offeringFixedCashAmount > 0 && `\u00A3${offeringFixedCashAmount}`}</>}
        ActionButton={
          <>
            {!offer.user.isMe && (
              <Button
                color="secondary"
                variant="contained"
                size="large"
                onClick={() => onActionButtonClick(offer)}
              >
                Go
              </Button>
            )}
          </>
        }
      />
    </div>
  );
};

export default DisplayOfferInGridWrapper;
